// @ services
const { get } = require('services/api');
// @ utilities
const apiURLBuilder = require('core/apiURLBuilder');
const Storage = require('utilities/storage');
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');
const {
    TIME_HORIZON_CHECK_ERROR,
    TIME_HORIZON_CHECK_NOT_PERFORMED,
    TIME_HORIZON_CHECK_VALID,
    TIME_HORIZON_CHECK_WARNING,
} = require('constants/RAConstants');

const setTimeHorizonCheck = newHorizonTime => ({
    type: actionTypes.RA_TIME_HORIZON_CHECK_SET_TIME,
    newHorizonTime,
});

const timeHorizonCheckInProgress = () => ({
    type: actionTypes.RA_TIME_HORIZON_CHECK_REQUEST,
});

const timeHorizonCheckSuccess = response => ({
    type: actionTypes.RA_TIME_HORIZON_CHECK_SUCCESS,
    payload: {
        HTPI: response.timeHorizon || false,
        ipModification: response.modificationOfInvestmentProfile,
        maxTypeOfProduct: response.maxTypeOfProduct || 0,
    },
});

const timeHorizonCheckFailure = error => ({
    type: actionTypes.RA_TIME_HORIZON_CHECK_FAILURE,
    payload: error,
});

const resetMaxTypeOfProduct = () => ({
    type: actionTypes.RA_TIME_HORIZON_CHECK_RESET_TIME_HORIZON_CHECK,
});

const timeHorizonCheck =
    (validCallback = () => {}, warningCallback = () => {}) =>
    (dispatch, getState) => {
        const status = getState().raTimeHorizonCheck.get('status');

        if (status == TIME_HORIZON_CHECK_WARNING || status == TIME_HORIZON_CHECK_VALID) {
            validCallback();
        } else if (status == TIME_HORIZON_CHECK_ERROR || status == TIME_HORIZON_CHECK_NOT_PERFORMED) {
            const newHorizonTime = getState().raTimeHorizonCheck.get('newHorizonTime');
            const openBankToken = Storage.cookies.get('openBankToken');
            const requestData = {
                header: {
                    openBankAuthToken: openBankToken,
                },
            };

            dispatch(timeHorizonCheckInProgress());

            return get(apiURLBuilder.getURL('raTimeHorizonCheck', { timeHorizon: newHorizonTime }), requestData)
                .then(response => {
                    dispatch(timeHorizonCheckSuccess(response.body));
                    const status = getState().raTimeHorizonCheck.get('status');

                    if (status == TIME_HORIZON_CHECK_VALID) {
                        validCallback();
                    } else if (status == TIME_HORIZON_CHECK_WARNING) {
                        warningCallback();
                    }
                })
                .catch(error => {
                    if (error) {
                        dispatch(timeHorizonCheckFailure(error.description));
                    } else {
                        throw error;
                    }
                });
        }
    };

export default {
    setTimeHorizonCheck,
    resetMaxTypeOfProduct,
    timeHorizonCheck,
};
